import { PlatformUtils } from '@eo-storefronts/eo-core'
import { SxProps } from '@mui/material'
import TemplateServiceStyleBase from '~/src/utils/template/TemplateServiceStyleBase'
import StylesOrderServiceInterface from '~/src/components/orders/order-layout/styles/StylesOrderServiceInterface'

export default class StylesOrderServiceStyleTwo extends TemplateServiceStyleBase implements StylesOrderServiceInterface {
  public getPageSx(): SxProps {
    return {
      pt: 4,
      minHeight: '100%',
      [this.muiTheme.breakpoints.down('md')]: {
        p: 2,
        pt: this._getDownMdPtForPageSx()
      }
    }
  }

  private _getDownMdPtForPageSx() {
    if (!PlatformUtils().isCapacitorNative) {
      return 2
    }

    if (this.layout?.header.display) {
      return 0
    }

    return `calc(var(--eo-safe-area-top) + ${this.muiTheme.spacing(3)})`
  }
}
